import PageTerraformWorkspacesDetail from 'hcp/components/page/terraform/workspaces/detail';

<template>
  <PageTerraformWorkspacesDetail
    @workspace={{@model.workspace}}
    @organizationId={{@model.organizationId}}
    @projectId={{@model.projectId}}
  />
</template>
